import { render, staticRenderFns } from "./MspBestRecord.vue?vue&type=template&id=417992f5"
import script from "./MspBestRecord.vue?vue&type=script&lang=js"
export * from "./MspBestRecord.vue?vue&type=script&lang=js"
import style0 from "./MspBestRecord.vue?vue&type=style&index=0&id=417992f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports